<template>
    <div>
        <modal
        class="new-modal-default"
        :name="modal_name"
        transition="nice-modal-fade"
        :delay="100"
        :width="650"
        :height="350"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">Select {{ type }}</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideSelf"></span>
                    </div>
                </div>
                <div class="v-modal-body overflow-hidden">
                    <div class="v-modal-layout">
                        <div class="d-flex align-items-center justify-content-between flex-column mt-4 px-8">
                            <div class="w-100">
                                <input class="w-100 mb-2" type="text" v-model="search_key" @keyup="getOptions" placeholder="Search..." style="border-bottom: 1px solid #000; height: 2em;">
                                <div class="d-flex align-items-center flex-column" id="option-list">
                                    <span class="pointer fs-14 fw-600 my-2" v-for="(option,index) in productsOptions" :key="index" @click="optionSelected(option)">{{ option.name }}</span>
                                    <span class="pointer fs-14 fw-600 my-2" v-for="(option,index) in salesPersonOptions" :key="index" @click="optionSelected(option)">{{ option.full_name }}</span>
                                    <span class="pointer fs-14 fw-600 my-2" v-for="(option,index) in uomOptions" :key="index" @click="optionSelected(option)">{{ option }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import globals from "../globals";
export default {
    data() {
        return {
            productsOptions: [],
            salesPersonOptions: [],
            uomOptions: [],
            isLoading: false,
            search_key: "",
            add_to_list: false,
        }
    },
    props: ["modal_name","type","label"],
    methods: {
        infinteScroll() {
            var scrollTop = document.getElementById('option-list').scrollTop;
            var scrollHeight = document.getElementById('option-list').scrollHeight; 
            var offsetHeight = document.getElementById('option-list').offsetHeight;
            var clientHeight = document.getElementById('option-list').clientHeight;
            var contentHeight = scrollHeight - offsetHeight; 
            if (contentHeight <= scrollTop)
            {
                if(!this.infinite_scroll_reached_end) {
                    this.add_to_list = true;
                    this.getOptionsAfter();
                }
            }
        },
        hideSelf() {
            this.options = [];
            this.isLoading = false;
            this.search_key = "";
            this.$emit("close");
            this.$modal.hide(this.modal_name);
        },
        getOptions() {
            if (this.type == "Product Name") {
                this.getProduts();
            }
            if (this.type == "Sales Person") {
                this.fetchSalesPerson();
            }
            if (this.type == "UM") {
                this.getuom();
            }
        },
        getOptionsAfter() {
            if (this.type == "Product Name" && this.add_to_list) {
                this.getProdutsAfter();
            }
            if (this.type == "Sales Person" && this.add_to_list) {
                this.fetchSalesPersonAfter();
            }
            if (this.type == "UM" && this.add_to_list) {
                this.getuomafter();
            }
        },
        optionSelected(option) {
            if (this.type == "Product Name") {
                this.$emit("selected", this.type, option);
            }
            if (this.type == "Sales Person") {
                this.$emit("selected", this.type, option);
            }
            if (this.type == "UM") {
                this.$emit("selected", this.type, option);
            }
            this.hideSelf();
        },
        dropdownClosed() {
            this.options = [];
            this.isLoading = false;
            this.search_key = "";
        },
        async getProduts() {
            this.isLoading = true;
            let params = {
                skip: 0,
                limit: 10,
                search: this.search_key,
            };
            let res = await this.$http.post(globals.SCM_API + "/fnb/scm/get_product_listing_data", params);
            if (res.data.status_id == 1) {
                this.productsOptions = [];
                if (res.data.products) {
                    res.data.products.forEach(x => {
                        if ("name" in x) {
                            this.productsOptions.push(x);
                        }
                    });
                    this.isLoading = false;
                }
            }
        },
        async getProdutsAfter() {
            if (this.add_to_list && this.options.length >= 10) {
                let params = {
                    skip: this.options.length,
                    limit: 10,
                    search: this.search_key,
                };
                let res = await this.$http.post(globals.SCM_API + "/fnb/scm/get_product_listing_data", params);
                if (res.data.status_id == 1) {
                    if (res.data.products) {
                        res.data.products.forEach(x => {
                            if ("name" in x) {
                                this.productsOptions.push(x);
                            }
                        });
                    }
                }
            };
        },
        async fetchSalesPerson() {
            this.isLoading = true;
            let params = {
                search_key: this.search_key,
                skip: 0,
                limit: 10,
                company_id: this.selectedCompany._id,
                active_status: "active",
            };
            let res = await this.$http.post("employees/get_employees", params);
            if (res.data.status_id == 1) {
                this.salesPersonOptions = [];
                res.data.response.forEach(x => {
                    this.salesPersonOptions.push(x);
                });
                this.isLoading = false;
            }
        },
        async fetchSalesPersonAfter() {
            if (this.add_to_list) {
                let params = {
                    search_key: this.search_key,
                    skip: this.options.length,
                    limit: 10,
                    company_id: this.selectedCompany._id,
                    active_status: "active",
                };
                let res = await this.$http.post("employees/get_employees", params);
                if (res.data.status_id == 1) {
                    res.data.response.forEach(x => {
                        this.salesPersonOptions.push(x);
                    });
                }
            };
        },
        async getuom() {
            this.isLoading = true;
            let params = {
                search_key: this.search_key,
                skip: 0,
                limit: 10,
            };
            let res = await this.$http.post(
                globals.SCM_API + "/fnb/scm/get_unit_of_measurements",
                params
            );
            if (res.data.status_id == 1) {
                this.uomOptions = [];
                if (res.data.unit_of_measurements) {
                    res.data.unit_of_measurements.forEach(x => {
                        this.uomOptions.push(x.name);
                    });
                    this.isLoading = false;
                }
            }
        },
        async getuomafter() {
            if (this.add_to_list) {
                let params = {
                    search_key: this.search_key,
                    skip: this.options.length,
                    limit: 10,
                };
                let res = await this.$http.post(globals.SCM_API + "/fnb/scm/get_unit_of_measurements", params);
                if (res.data.status_id == 1) {
                    if (res.data.unit_of_measurements) {
                        res.data.unit_of_measurements.forEach(x => {
                            this.uomOptions.push(x.name);
                        });
                    }
                }
            };
        },
    },
    computed: {
        selectedCompany() {
            return this.$store.getters.selectedCompany;
        },
    },
    created() {
        this.getOptions();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/SelectSalesForecastDropdown.vue